export const LODGEMENTS = ['Complaint', 'Feedback', 'Compliment', 'Financial hardship application'];
